import { Box, Stack, styled } from "@mui/material";

export const Container = styled(Stack)`
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;
  gap: 0.3em;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;

  background-color: #f8f8f8;
`;

export const Title = styled(Box)`
  font-size: 1.5em;
  font-weight: bold;

  @media screen and (max-width: 640px) {
    font-size: 1.2em;
  };

  @media screen and (max-width: 420px) {
    font-size: 1em;
  };
`;

